<template>
  <div class="popup-title">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.popup-title {
  font-size: 24px;
  font-weight: 600;
  color: #09090B;
  padding-right: 24px;
  margin-bottom: 16px;
}
</style>
